import { SentryRoute } from "index";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import FixedLangSwitcher from "../../components/FixedLangSwitcher/FixedLangSwitcher";
import Subscribed from "./Newsletter/Subscribed";

const MiscRouter = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <SentryRoute exact path={`${path}/newsletter/subscribed`}>
          <Subscribed />
        </SentryRoute>
      </Switch>
      <div className="lang-switcher-wrapper">
        <FixedLangSwitcher />
      </div>
    </>
  );
};

export default MiscRouter;
